const allowedSignalKinds = ['signal'];
export { allowedSignalKinds };
//# sourceMappingURL=allowedSignalKinds.js.map